module.exports = __webpack_public_path__ + "img/unfollow.247b1ff8.png";